import React from 'react';
import PropTypes from 'prop-types';

import { daysSince, qformat, DATE_FORMATS } from 'views_shared/app/javascript/utils/dateFormatters';

function formatDateLabel(date) {
  const days = daysSince(date);

  if (days === 0) return 'Today';
  if (days === 1) return 'Yesterday';

  return qformat(date, DATE_FORMATS.dateNoYear).toUpperCase();
}

function DateSeparator({ date }) {
  return (
    <div className="position-relative text-center my-3">
      <hr className="my-0" />

      <span className="position-absolute top-50 start-50 translate-middle px-3 paragraph-sm text-secondary bg-body">
        {formatDateLabel(date)}
      </span>
    </div>
  );
}

DateSeparator.propTypes = {
  date: PropTypes.string.isRequired,
};

export default DateSeparator;
